export const PLAN_CUSTOMIZATION_HOOKS = {
  DATE_PICKER: 'plan-customization.date-picker-input',
  PLAN_CUSTOMIZATION_PAGE: 'plan-customization.page',
} as const;
